import { render, staticRenderFns } from "./LicenseRedirectChecker.vue?vue&type=template&id=adf912c4"
import script from "./LicenseRedirectChecker.vue?vue&type=script&lang=ts"
export * from "./LicenseRedirectChecker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports